import { withInstall } from '../utils/index';
import _Select from './index.vue';
import './index.less';

export const TlbsSugSelect = withInstall(_Select);

export default TlbsSugSelect;
